import data from "../../../../../src/TextInputWithTokens/TextInputWithTokens.docs.json";
import { TextInputWithTokens } from '@primer/react';
import * as React from 'react';
export default {
  data,
  TextInputWithTokens,
  React
};